import classcat from "classcat";
import React, { useCallback, useMemo } from "react";

import css from "./SizeSelector.module.css";

type Props = {
  items: string[];
  availableItems: string[];
  selectedItem?: string;
  onChange: (item: string) => void;
};

const ROW_SIZE = 5;

const SizeSelector = ({
  items,
  availableItems,
  selectedItem,
  onChange,
}: Props) => {
  const rows = useMemo(
    () =>
      items.reduce(
        (acc, item) => {
          const lastRow = acc[acc.length - 1];
          if (lastRow.length < ROW_SIZE) {
            lastRow.push(item);
          } else {
            acc.push([item]);
          }
          return acc;
        },
        [[]]
      ),
    [items]
  );

  const handleClick = useCallback(
    (event: React.SyntheticEvent<HTMLTableCellElement>) => {
      onChange(event.currentTarget.dataset.key);
    },
    [onChange]
  );

  return (
    <table className={css.container}>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <td
                className={classcat([
                  "text-label-base",
                  css.cell,
                  {
                    [css.unavailableSizeAndLength]:
                      !availableItems.includes(cell),
                    [css.selected]: cell === selectedItem,
                    [css.singleCell]: items.length === 1,
                  },
                ])}
                data-key={cell}
                key={cellIndex}
                onClick={handleClick}
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SizeSelector;
